import { Quill } from 'vue2-editor';

const Font = Quill.import('formats/font');

Font.whitelist = [
  'Roboto',
  'Open-Sans',
  'Gotham',
  'Bodoni',
  'Austin',
  'Playfair-display',
];

export default Font;
